<!--
 * @Author: chenming
 * @LastEditors: chenming
 * @Description: 滑块
-->
<template>
  <div class="lc-slider">
    <label v-if="showRangeText" class="lc-slider-text">{{ min }}</label>
    <el-slider v-model="sliderNumber" :min="min" :max="max" :step="step" v-bind="$attrs" />
    <label v-if="showRangeText" class="lc-slider-text">{{ max }}</label>
  </div>
</template>
<script>
export default {
  name: 'LcSlider',
  components: {},
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    // 显示范围
    showRangeText: {
      type: Boolean,
      default: true
    },
    // 步长
    step: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: 100,
    },
    min: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      formValue: 0
    };
  },
  computed: {
    sliderNumber: {
      get() {
        return this.formValue;
      },
      set(v) {
        this.formValue = v;
      }
    }
  },
  watch: {
    formValue: function (val) {
      this.$emit('input', val);
    },
  },
  created() {
    this.formValue = this.value;
  },
  mounted() {
    // preset
  },
  methods: {}
};
</script>
<style lang="scss">
@import '@/styles/element-ui.scss';
.lc-slider {
  display: flex;
  align-items: center;
  @if $width =='fullWidth' {
    width: 100%;
  }

  @else if $width =='mini' {
    width: 60px;
  }

  @else {
    width: #{$width};
  }
  .el-slider {
    flex: 1;
    margin: 0 10px;
    .el-slider__button-wrapper {
      width: 32px;
      height: 32px;
      top: -13px;
    }
    .el-slider__runway {
      margin: 13px 0;
    }
  }
  &-text {
    padding: 0 5px;
  }
}
</style>
